import { NgModule, Optional, SkipSelf } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CompanyConfigEffects } from './company-config.effects';
import { ICompanyConfigFeature } from './company-config.feature.state';
import { CompanyConfigReducer } from './company-config.reducer';
import { nameof } from '@symphony-solo/shared/utils/src';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<ICompanyConfigFeature>('CompanyConfigFeature'), CompanyConfigReducer),
    EffectsModule.forFeature([CompanyConfigEffects]),
  ],
})
export class CompanyConfigStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: CompanyConfigStateModule
  ) {
    if (parentModule) {
      throw new Error('CompanyConfigStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
